import React from 'react';
import { TableRowItemData } from '../../../components/Table';
import { format } from 'date-fns/esm';
import { parseISO } from 'date-fns';
import { Button } from '@wot/components';
import { useNavigate } from 'react-router-dom';
import xhr from '../../../utils/fetch';
import { toast } from 'react-toastify';

const TableRowitem = ({ data }: any) => {
  // format(parseISO(data?.data?.updatedAt), 'dd/MM/yyyy')
  const navigate = useNavigate();
  const handleDelete = (subId: any, subjectname: string) => {
    const text = `Are You Sure delete ${subjectname}`;
    if (confirm(text)) {
      xhr({
        url: `/s/deleteSubject/${subId}`,
        method: 'DELETE'
      })
        .then((res) => toast.success(res.message))
        .catch((err) => err);
    }
  };
  return (
    <>
      {data?.updatedAt && <TableRowItemData text={format(parseISO(data?.updatedAt), 'dd/MM/yyyy')} />}
      <TableRowItemData text={data?.subject_category.name} />
      <TableRowItemData text={data?.name} />
      <TableRowItemData text={data?.id} />
      <TableRowItemData
        component={(() => {
          return (
            <Button
              text="Edit subject"
              className="!py-1.5 !bg-primary !border-primary"
              onClick={() => {
                navigate(`/curriculum/update/${data?.id}`);
              }}
            />
          );
        })()}
      />
      <TableRowItemData
        component={(() => {
          return (
            <Button text="Delete subject" className="!py-1.5 " onClick={() => handleDelete(data?._id, data?.name)} />
          );
        })()}
      />
    </>
  );
};

export default TableRowitem;
